import React from 'react';
import './ObservationCard.css';
import { Calendar, MapPin, ExternalLink } from 'lucide-react';

const ObservationCard = ({ observation }) => {
  const {
    taxon,
    observed_on_details,
    place_guess,
    photos,
    uri
  } = observation;

  const photoUrl = photos && photos.length > 0 
    ? photos[0].url.replace('square', 'medium') 
    : 'https://via.placeholder.com/300x200?text=No+Photo';

  const commonName = taxon?.preferred_common_name || "Unknown Species";
  const scientificName = taxon?.name || "Unknown Taxon";
  const date = observed_on_details?.date || "Date unknown";
  const location = place_guess || "Location unknown";

  return (
    <div className="observation-card">
      <div className="card-image-wrapper">
        <img src={photoUrl} alt={commonName} loading="lazy" />
        <a href={uri} target="_blank" rel="noopener noreferrer" className="external-link" title="View on iNaturalist">
          <ExternalLink size={18} />
        </a>
      </div>
      <div className="card-content">
        <h3 className="species-common">{commonName}</h3>
        <p className="species-scientific"><em>{scientificName}</em></p>
        
        <div className="card-meta">
          <div className="meta-item">
            <Calendar size={14} />
            <span>{date}</span>
          </div>
          <div className="meta-item">
            <MapPin size={14} />
            <span>{location}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ObservationCard;
